import {
  Home,
  Settings,
  Users,
  MessageCircle,
  MessageSquare,
  Plus,
  ChartArea,
  ListOrdered,
} from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.jpg";

export default function Sidebar() {
  const location = useLocation(); // ✅ get current route

  const navItems = [
    {
      name: "Home",
      icon: <Home className="w-5 h-5" />,
      path: "/dashboard",
      end: true,
    },
    {
      name: "Add Funds",
      icon: <Plus className="w-5 h-5" />,
      path: "/dashboard/add/money",
    },
    {
      name: "SMS Verification",
      icon: <MessageSquare className="w-5 h-5" />,
      path: "/dashboard/BuySmsRoutePage",
    },
    {
      name: "SMS Orders",
      icon: <ListOrdered className="w-5 h-5" />,
      path: "/dashboard/SmsOrder",
    },
    {
      name: "Transactions",
      icon: <ChartArea className="w-5 h-5" />,
      path: "/dashboard/transactions",
    },
    {
      name: "Community",
      icon: <Users className="w-5 h-5" />,
      path: "/dashboard/community",
    },
    {
      name: "Chat Us",
      icon: <MessageCircle className="w-5 h-5" />,
      path: "/dashboard/chat",
    },
    {
      name: "Settings",
      icon: <Settings className="w-5 h-5" />,
      path: "/dashboard/settings",
    },
  ];

  return (
    <aside className="w-64 bg-white shadow-md hidden md:flex flex-col">
      <div className="flex items-center px-6 py-6 text-2xl font-bold text-[#007AFF] border-b">
        <img
          src={logo}
          alt="DottiVerify Logo"
          className="w-10 object-cover rounded-full mr-2"
        />
        <span>Dotti Verify</span>
      </div>

      <nav className="flex-1 px-4 py-6 space-y-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;

          return (
            <NavLink
              key={item.name}
              to={item.path}
              end={item.end}
              className={`flex items-center gap-3 px-4 py-2 rounded-lg transition-colors duration-200 ${
                isActive
                  ? "bg-[#007AFF]/5 text-[#007AFF] font-medium"
                  : "text-gray-600 hover:bg-gray-100"
              }`}
            >
              {item.icon}
              <span>{item.name}</span>
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
}
